import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import SurveyInputComp from "./components/SurveyInputComp";
import { inputTypes, tableData } from "../../utils/tableData";
import { useSearchParams, useNavigate } from "react-router-dom";
import { addDoc, collection, doc, getDoc } from "firebase/firestore";
import { collectionNames, routes } from "../../utils/Constants";
import { auth, db } from "../../utils/firebase";
import Button from "../../components/Button";
import { htmlStringToPdf } from "../../helpers/htmlToPdf";
import { FaDownload } from "react-icons/fa";
import LiknExpiredComp from "./components/LiknExpiredComp";
import * as Yup from "yup";
import moment from "moment";
import TextAreaInput from "../../components/TextAreaInput";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Required"),
});
const Survey = () => {
  const [session, setSession] = useState();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [expiredLink, setExpiredLink] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const submitSurvey = async (values) => {
    console.log(values, "vvvv");
    try {
      const docRef = await addDoc(collection(db, collectionNames.SURVEYS), {
        ...values,
        userId: auth?.currentUser?.email ?? null,
        timestamp: new Date(),
        sessionId: session.id,
      });
      setIsSubmitted(true);
      alert("Submitted successfully");
    } catch (error) {
      console.log(error);
    }
  };
  const getInitialValues = () => {
    let tmpInitial = {};
    tableData.forEach((a) => {
      if (a.subs) {
        a.subs.forEach((sub) => {
          if (sub.input.type == inputTypes.slider) {
            tmpInitial[sub.input.name] = 50;
          }
        });
      } else {
        if (a.input.type == inputTypes.slider) {
          tmpInitial[a.input.name] = 50;
        }
      }
    });
    return tmpInitial;
  };
  const { handleSubmit, handleChange, values, setFieldValue, isSubmitting } =
    useFormik({
      initialValues: { ...getInitialValues() },
      onSubmit: submitSurvey,
    });

  const getSurveyDetails = async () => {
    const sessionId = searchParams.get("id");
    if (!sessionId) return alert("Invalid link");
    const docRef = doc(db, collectionNames.SESSIONS, sessionId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      if (docSnap.data().status == "closed") {
        alert("Link Expired");
        setExpiredLink(true);
      } else {
        setSession({ id: docSnap.id, ...docSnap.data() });
      }
    } else {
      // docSnap.data() will be undefined in this case
      alert("Invalid link");
      return navigate(routes.NOT_FOUND);
    }
  };
  const downloadHandler = async () => {
    let innerHtml = "";

    tableData.forEach((dt) => {
      const splitimgName1 = dt.titleImg.split("/");
      const splitimgName = splitimgName1[splitimgName1.length - 1];
      const imgName = splitimgName.split(".")[0];
      let tags = "";
      if (dt.subs) {
        dt.subs.forEach((sub) => {
          if (sub.input.textAreas) {
            tags += `<div style="width:550px;" >`; //div opening 123
            sub.input.textAreas.forEach((ta) => {
              tags += `<div style="display:flex;gap:10px;" >
             <p>${ta.label}:</p>
              <p>${values[ta.name]}</p>
             </div>`;
            });
            tags += `</div>`; // div closing 123
          } else {
            tags += `<p style="width:230px;" >${
              (sub.input.name == "helpful") | (sub.input.name == "impairment")|(sub.input.name == "type")
                ? ""
                : sub.title
            }</p>${
              sub?.input?.type === inputTypes.slider
                ? ` <div id="slider" style="margin-top:10px; width: 200px; height: 15px; background-color: lightgray; position: relative; border-radius:10px; overflow:hidden">
              <div id="thumb" style="width: ${
                values[sub.input.name] * 2
              }px; height: 15px; background-color: gray; position: absolute; top: 0; left: 0;"></div>
            </div>`
                : ` 
                <div style="display:flex;gap:10px;" > 
                 <p>${sub.input.label ? sub.input.label + ":" : ""}</p>
                <p>${
                  values[sub.input.name]
                    ? Array.isArray(values[sub.input.name])
                      ? values[sub.input.name].join(", ")
                      : values[sub.input.name]
                    : ""
                }</p>
                
                </div>`
            }`;
          }
        });
        if (tags) {
          innerHtml += `
        <div style="display:flex;width:100%;border:1px solid grey" >
         
        <div style="padding:10px; width:200px;display:flex;align-items:center;justify-content:center;background-color:${dt.bg};flex-shrink:0;">
        <img src="/images/${imgName}.png" style="width:100px;height:100px;object-fit:contain"/>
        </div>

        <div style="padding:10px" >
        ${tags}
        </div>
        </div>
        `;
        }
      } else {
      }
    });

    // tableData.forEach((dt) => {
    //   if (dt.subs) {
    //     dt.subs.forEach((dt2) => {
    //       if (!values[dt2.input.name]) return;
    //       const splitimgName1 = dt.titleImg.split("/");
    //       const splitimgName = splitimgName1[splitimgName1.length - 1];
    //       const name = splitimgName.split(".")[0];

    //       innerHtml += `<div style=" margin-bottom:15px; display:flex; align-items:center; " >
    //             <img src="/images/${name}.png" style="width:100px;height:100px;" />
    //       <p style="width:230px; " >${
    //         (dt2.input.name == "helpful") | (dt2.input.name == "impairment")
    //           ? "Functional Behaviours"
    //           : dt2.title
    //       }</p>${
    //         dt2?.input?.type === inputTypes.slider
    //           ? ` <div id="slider" style="margin-top:10px; width: 200px; height: 15px; background-color: lightgray; position: relative; border-radius:10px; overflow:hidden">
    //         <div id="thumb" style="width: ${
    //           values[dt2.input.name] * 2
    //         }px; height: 15px; background-color: gray; position: absolute; top: 0; left: 0;"></div>
    //       </div>`
    //           : ` <p>${values[dt2.input.name]}</p>`
    //       }
    //              </div>`;
    //     });
    //   } else {
    //     innerHtml += `<div style=" margin-bottom:15px; display:flex; align-items:center; " >
    //               <p style="width:230px; " >${
    //                 (dt.input.name == "helpful") |
    //                 (dt.input.name == "impairment")
    //                   ? "Functional Behaviours"
    //                   : dt.title
    //               }</p>${
    //       dt?.input?.type === inputTypes.slider
    //         ? ` <div id="slider" style="margin-top:10px; width: 200px; height: 15px; background-color: lightgray; position: relative; border-radius:10px; overflow:hidden">
    //         <div id="thumb" style="width: ${
    //           values[dt.input.name] * 2
    //         }px; height: 15px; background-color: gray; position: absolute; top: 0; left: 0;"></div>
    //       </div>`
    //         : ` <p>${values[dt.input.name]}</p>`
    //     }
    //              </div>`;
    //   }
    // });
    // Object.keys(values).forEach((key) => {
    //   if (key != "id" || key != "userId" || key != "timestamp") {
    //     innerHtml += `<div style=" margin-bottom:15px; display:flex; align-items:center; " >
    //               <p style="width:230px; " >${
    //                 (key == "helpful") | (key == "impairment")
    //                   ? "Functional Behaviours"
    //                   : getConfigDataByName(key)?.title
    //               }</p>${
    //       getConfigDataByName(key)?.input?.type === inputTypes.slider
    //         ? ` <div id="slider" style="margin-top:10px; width: 200px; height: 15px; background-color: lightgray; position: relative; border-radius:10px; overflow:hidden">
    //         <div id="thumb" style="width: ${
    //           values[key] * 2
    //         }px; height: 15px; background-color: gray; position: absolute; top: 0; left: 0;"></div>
    //       </div>`
    //         : ` <p>${values[key]}</p>`
    //     }
    //              </div>`;
    //   }
    // });

    const wholeHtml = `<div style="width:1000px; display:flex;flex-direction:column; align-items:center; justify-content:center; " >
    <p style="font-size:20px; font-weight:700; margin-bottom:5px;" >${
      session.name
    }</p>
    <p style="font-size:12px;margin-top:0px;" >${moment(new Date()).format(
      "DD-MM-YYYY"
    )}</p>
    <div style="width:80%" >
    ${innerHtml}
    </div>
    </div>`;

    const pdf = await htmlStringToPdf(wholeHtml);

    var pdfUrl = URL.createObjectURL(pdf);

    var link = document.createElement("a");

    link.setAttribute("download", "Survey.pdf");

    link.href = pdfUrl;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);

    URL.revokeObjectURL(pdfUrl);
  };
  useEffect(() => {
    getSurveyDetails();
  }, []);

  if (expiredLink) return <LiknExpiredComp />;

  return (
    <div className="p-3 ">
      <p className="mb-3 text-3xl text-center">
        Musculoskeletal Clinical Translation Framework
      </p>
      <form onSubmit={handleSubmit}>
        <div className="border ">
          <SurveyInputComp
            input={{
              type: inputTypes.textArea,
              name: "mainProplem",
              label: "Main Problem",
              containerStyle: "w-full",
            }}
            setFieldValue={setFieldValue}
            value={values.mainProplem}
          />
          {tableData.map((item, idx) => (
            <div key={idx} className="mb-3 sm:mb-0 flex flex-col sm:flex-row">
              <div
                className=" w-full sm:w-1/5 bg-gray-300 flex items-center justify-center"
                style={{ backgroundColor: item.bg }}
              >
                {/* <p className="sm:text-center">{item.title}</p> */}
                {item.titleImg && (
                  <img
                    src={item.titleImg}
                    className=" w-1/2 h-1/2 md:w-3/4 md:h-3/4 object-contain"
                  />
                )}
              </div>

              <div className="border  w-full ">
                {/* To show if sub items are there */}
                {item.subs ? (
                  <div className="h-full flex flex-col ">
                    {item.subs.map((sub, idx) => (
                      <div
                        className="flex-1 flex flex-col sm:flex-row "
                        key={idx}
                        // style={{ height: (100 / item.subs.length)+ "%" }}
                      >
                        <div className=" sm:w-[200px]  p-2 flex  items-center sm:justify-center sm:border-r">
                          <p className="text-center sm:w-1/2 ">{sub.title}</p>
                        </div>
                        <div>
                          <SurveyInputComp
                            input={sub.input}
                            setFieldValue={setFieldValue}
                            value={values[sub.input.name]}
                            values={values}
                            title={item.title}
                          />
                          {sub.input.name == "clinicalDecisionMaking" && (
                            <div className="px-2 -mt-3 flex gap-5">
                              {/* <TextAreaInput
                                value={values.goalsOrExpectations}
                                onChange={(e) =>
                                  setFieldValue(
                                    "goalsOrExpectations",
                                    e.target.value
                                  )
                                }
                              /> */}
                              <TextAreaInput
                                label={"Diagnosis"}
                                value={values.diagnosis_input}
                                onChange={(e) =>
                                  setFieldValue(
                                    "diagnosis_input",
                                    e.target.value
                                  )
                                }
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <SurveyInputComp
                    input={item.input}
                    setFieldValue={setFieldValue}
                    value={values[item.input.name]}
                  />
                )}
              </div>
            </div>
          ))}
          <div className="flex items-center justify-center space-x-3">
            <Button
              label={isSubmitted ? "✓ Form Submitted" : "Submit"}
              type="submit"
              containerStyle={"w-1/5"}
              loading={isSubmitting}
              disabled={isSubmitting}
            />
            <FaDownload
              title="Download"
              className="cursor-pointer"
              size={30}
              onClick={() => downloadHandler()}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default Survey;
